module.exports = __webpack_public_path__ + "static/media/tela_login.1ff01d97.png";